
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


import Home from "./components/pages/Home";
import Contacts from "./components/pages/Contacts";
import Ring from "./components/pages/Ring";
import Chain from "./components/pages/Chain";
import Chainpage from "./components/pages/Chainpage";
import Bala from "./components/pages/Bala";

import Jhumka from "./components/pages/Jhumka";
import Babybala from "./components/pages/Babybala";
import Bawty from "./components/pages/Bawty";
// import Chik from "./components/pages/Chik";
import Bracelet from "./components/pages/Bracelet";
import Locket from "./components/pages/Locket";

import Silck from "./components/pages/Silck";
import Footer from "./components/inc/Footer";


import Glasschur from './components/pages/Glasschur';
import Astro from './components/pages/Astro';
import Stone from './components/pages/Stone';

import Lockek2879 from './components/pages/Lockek2879';
import Lockethans from './components/pages/Lockethans';
import Lockethome from './components/pages/Lockethome';
import Necklacepage from './components/pages/Necklacepage';
import Career from './components/pages/Career';
import Passa from './components/pages/Passa';
import Terms from './components/pages/Terms';
import Privacy from './components/pages/Privacy';
import Ramnabami2025 from './components/pages/Ramnabami2025';
import Pipehar from './components/pages/Pipehar';
import BraceletPola from './components/pages/BraceletPola';


import Churnew from './components/pages/Churnew';
import Dulpage from './components/pages/Dulpage';
import Solidchuripage from './components/pages/Solidchuripage';
import GlassChurnew from './components/pages/GlassChurnew';
import ChokerNpage from './components/pages/ChokerNpage';
import Mantashapage from './components/pages/Mantashapage';
import Sankhapage from './components/pages/Sankhapage';
import LadiesCpage from './components/pages/LadiesCpage';
import Pola from './components/pages/Pola';
import PearlBelther from './components/pages/PearlBelther';
import BraceletLoha from './components/pages/BraceletLoha';
import SolidBala from './components/pages/SolidBala';
import BeltharPage from './components/pages/BeltharPage';
import LocketFilterPage from './components/pages/LocketFilterPage';
import KhapNecklace from './components/pages/KhapNecklace';
import ChataiNecklace from './components/pages/ChataiNecklace';
import FullKan from './components/pages/FullKan';
import Jhumkapage from './components/pages/Jhumkapage';







function App() {
  return (
    <Router>

      <div>



        <Routes>

          <Route axact path="/" element={<Home />} />
          <Route axact path="/contact" element={<Contacts />} />
          <Route axact path="/ring" element={<Ring />} />
          <Route axact path="/babychain" element={<Chain />} />
          <Route axact path="/chain" element={<Chainpage />} />
          <Route axact path="/bala" element={<Bala />} />
          <Route axact path="/jhumka" element={<Jhumka />} />
          <Route axact path="/babybala" element={<Babybala />} />



          <Route axact path="/bracelet" element={<Bracelet />} />

          <Route axact path="/Bangles" element={<Bawty />} />

          <Route axact path="/locket" element={<Locket />} />




          <Route axact path="/glasschur" element={<Glasschur />} />

          <Route axact path="/Astro" element={<Astro />} />
          <Route axact path="/stone" element={<Stone />} />
          <Route axact path="/silck" element={<Silck />} />
          <Route axact path="/Locketpage" element={<Lockethome />} />
          <Route axact path="/Lockek2879" element={<Lockek2879 />} />
          <Route axact path="/Locket3.200" element={<Lockethans />} />
          <Route axact path="/necklace-page" element={<Necklacepage />} />
          <Route axact path="/career" element={<Career />} />
          <Route axact path="/passa" element={<Passa />} />
          <Route axact path="/terms" element={<Terms />} />

          <Route axact path="/privacy" element={<Privacy />} />
          <Route axact path="/Ram_Navami_2025" element={<Ramnabami2025 />} />

          <Route axact path="/pipehar" element={<Pipehar />} />
             <Route axact path="/locketfilter" element={<LocketFilterPage/>} />
                    <Route axact path="/KhapNecklace" element={<KhapNecklace/>} />
          <Route axact path="/bracelet-pastingpola" element={<BraceletPola />} />
          <Route axact path="/mantasa" element={<Mantashapage />} />
          <Route axact path="/choker-necklace" element={<ChokerNpage />} />
          <Route axact path="/chur" element={<Churnew />} />
          <Route axact path="/dul" element={<Dulpage />} />
          <Route axact path="/solidchuri" element={<Solidchuripage />} />
          <Route axact path="/churpage" element={<GlassChurnew />} />
          <Route axact path="/sankha" element={<Sankhapage />} />
          <Route axact path="/ladieschain" element={<LadiesCpage />} />
            <Route axact path="/pola" element={<Pola/>} />
            <Route axact path="/chatai-necklace" element={<ChataiNecklace/>} />
            <Route axact path="/pearl-belther" element={<PearlBelther/>} />
               <Route axact path="/BraceletLoha" element={<BraceletLoha/>} />
                      <Route axact path="/solid-bala" element={<SolidBala/>} />
                        <Route axact path="/FullKan" element={<FullKan/>} />
                         <Route axact path="/jhumkapage" element={<Jhumkapage/>} />
                                 <Route axact path="/belthar" element={<BeltharPage/>} />
        </Routes>
        <Footer />

      </div>

    </Router>
  );
}

export default App;
